import { gql } from '@apollo/client';

const 

/** @description the settings a delivery plan card reads back after any write */

DELIVERY_PLAN_FIELDS = `

    id

    planId

    name

    enabled

    visibleInB2c

    masterPriceEnabled

    masterPrice

    basePrice

    minPrice

    freeDeliveryThreshold

    truckItemPrice

    distanceSurcharge

    bulkDiscountFrom

    bulkDiscountMultiplier

    priceFields

    pricing

    defaultPricing

`,

/** @description update a delivery method, its switches and its price settings */

UPDATE_DELIVERY_PLAN = gql`mutation UpdateDeliveryPlan (

    $id: ID!

    $enabled: Boolean

    $visibleInB2c: Boolean

    $masterPriceEnabled: Boolean

    $masterPrice: Float

    $basePrice: Float

    $minPrice: Float

    $freeDeliveryThreshold: Float

    $truckItemPrice: Float

    $distanceSurcharge: Float

    $bulkDiscountFrom: Int

    $bulkDiscountMultiplier: Float

    $pricing: JSON

    $replacePricing: Boolean

    $resetPricing: Boolean

) {

    adminUpdateDeliveryPlan (

        input: {

            id: $id

            deliveryPlanInput: {

                enabled: $enabled

                visibleInB2c: $visibleInB2c

                masterPriceEnabled: $masterPriceEnabled

                masterPrice: $masterPrice

                basePrice: $basePrice

                minPrice: $minPrice

                freeDeliveryThreshold: $freeDeliveryThreshold

                truckItemPrice: $truckItemPrice

                distanceSurcharge: $distanceSurcharge

                bulkDiscountFrom: $bulkDiscountFrom

                bulkDiscountMultiplier: $bulkDiscountMultiplier

                pricing: $pricing

                replacePricing: $replacePricing

                resetPricing: $resetPricing

            }

        }

    ) {

        deliveryPlan { ${ DELIVERY_PLAN_FIELDS } }

    }

}`,

/** @description register delivery methods that exist in code but have no row yet */

SYNC_DELIVERY_PLANS = gql`mutation SyncDeliveryPlans {

    adminSyncDeliveryPlans ( input: {} ) {

        addedPlanIds

        deliveryPlans { ${ DELIVERY_PLAN_FIELDS } }

    }

}`;

/** @export mutations */

export { UPDATE_DELIVERY_PLAN, SYNC_DELIVERY_PLANS }
